import { render } from "./logoComponent.vue?vue&type=template&id=23188127&scoped=true"
import script from "./logoComponent.vue?vue&type=script&lang=js"
export * from "./logoComponent.vue?vue&type=script&lang=js"

import "./logoComponent.vue?vue&type=style&index=0&id=23188127&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23188127"]])

export default __exports__